import { defineComponent, computed } from "vue";
import { V as VaIcon } from "../../../va-icon/index-7fefcddb.mjs";
import { u as useColors } from "../../../../composables/useColors-cd2c0b98.mjs";
const _sfc_main = defineComponent({
  name: "VaMessageList",
  components: { VaIcon },
  props: {
    modelValue: {
      type: [String, Array],
      default: ""
    },
    limit: { type: Number, default: 1 },
    color: { type: String },
    hasError: { type: Boolean, default: false }
  },
  setup(props) {
    const { getColor } = useColors();
    return {
      messages: computed(() => {
        if (!props.modelValue) {
          return [];
        }
        if (!Array.isArray(props.modelValue)) {
          return [props.modelValue];
        }
        return props.modelValue.slice(0, props.limit);
      }),
      computedStyle: computed(() => props.color ? { color: getColor(props.color) } : {})
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaMessageList.vue_vue_type_script_lang-8d2d236c.mjs.map
